import { useState, useEffect } from "react";
import {
  saveIncomingPO,
  fetchCompanyCodes,
  fetchCustomers,
  fetchProjects,
  fetchItems,
  fetchResources,
  fetchVendors,
  fetchTaxCodes,
  fetchHSNCodes,
  getCompanyByOrganisationId,
  fetchrevenueProjects,
  getSalesPerson,
   // Import the new function
} from "../Api/IncomingPo";
import { fetchResourceByOrgId } from "../Api/InvoiceApi";
import { fetchCurrency } from "../Api/InvoiceApi";
import {

  getItemTypes,
 
} from "../Api/PurchaseOrder";
import { fetchItemsByOrgId } from "../Api/IncomingPo";
import axios from "axios";
import { getAllMerchants } from "../Api/CustomerMaster";
import { fetchCustomersByOrgId } from "../Api/InvoiceApi";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
const IncomingPO = () => {
  // const userId = localStorage.getItem("userId") || "5";
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
const [itemTypes, setItemTypes] = useState([]);
const [loadingItemTypes, setLoadingItemTypes] = useState(false);

  const userId = userDetails?.userId; // For API call
  const orgId = userDetails?.organisationId; 
  const {user}=useAuth();
  console.log("User Details:", userDetails);
  console.log("User ID:", userId);
  console.log("Organisation ID:", orgId);
  const [companyCodes, setCompanyCodes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [items, setItems] = useState([]);
  const [resources, setResources] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [taxCodes, setTaxCodes] = useState([]);
  const [hsnCodes, setHsnCodes] = useState([]);

  const [loadingCompanyCodes, setLoadingCompanyCodes] = useState(false);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [loadingResources, setLoadingResources] = useState(false);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [loadingTaxCodes, setLoadingTaxCodes] = useState(false);
  const [loadingHsnCodes, setLoadingHsnCodes] = useState(false);
  const [currencyCode, setCurrencyCode] = useState([]);
  const[allResource,setAllResource]=useState([]);
  const [poData, setPoData] = useState({
    transactionType: "Incoming PO", // Default value
    companyCode: "",
    category: "",
    customerCode: "",
    projectCode: "",
    poNumber: "",
    poDate: "",
    salespersonCode: "",
    createdBy: user?.userId,
    currencyCode: "",
    organisationId:user?.organisationId,
    
    itemData: [
      {
        item: "",
        itemType: "", 
        resource: "",
        vendor: "",
        quantity: "",
        price: "",
        taxType: "",
        cgst: "",
        sgst: "",
        igst: "",
        hsn: "",
        grandTotal: "",
         itemDescription: "",
         currencyCode: "",
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const transactionTypeOptions = [
    { value: "Incoming PO", label: "Incoming PO" },
    { value: "Sales Order", label: "Sales Order" },
  ];

  const calculatePriceSummary = () => {
    let totalBasePrice = 0;
    let totalTaxAmount = 0;
    let totalPrice = 0;
    let roundedTotalPrice = 0;
    let roundOff = 0;

    poData.itemData.forEach((item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.price) || 0;
      const cgst = parseFloat(item.cgst) || 0;
      const sgst = parseFloat(item.sgst) || 0;
      const igst = parseFloat(item.igst) || 0;

      const basePrice = quantity * price;
      const taxAmount = basePrice * ((cgst + sgst + igst) / 100);

      totalBasePrice += basePrice;
      totalTaxAmount += taxAmount;
      totalPrice += basePrice + taxAmount;
    });

    roundedTotalPrice = Math.round(totalPrice);
    roundOff = roundedTotalPrice - totalPrice;

    return {
      totalBasePrice: totalBasePrice.toFixed(2),
      totalTaxAmount: totalTaxAmount.toFixed(2),
      totalPrice: totalPrice.toFixed(2),
      roundedTotalPrice: roundedTotalPrice.toFixed(2),
      roundOff: roundOff.toFixed(2),
    };
  };
  const fetchProjectsByCustomer = async (customerCode) => {
  const res = await axios.get(
    `${Base_URL}/ProjectMaster/GetProjectsByCustomer/${customerCode}`
  );
  return Array.isArray(res.data) ? res.data : [res.data];
};

  const priceSummary = calculatePriceSummary();

  useEffect(() => {
    const loadData = async () => {
      setLoadingCompanyCodes(true);
      setLoadingCustomers(true);
      setLoadingProjects(true);
      setLoadingItems(true);
      setLoadingResources(true);
      setLoadingVendors(true);
      setLoadingTaxCodes(true);
      setLoadingHsnCodes(true);
      console.log("Loading data...");
      try {
        // First, get company data by organization ID
        if (orgId) {
          console.log("Fetching company data for organisation ID:", orgId);
          const companyData = await getCompanyByOrganisationId(orgId);
          console.log("Company Data by Organisation ID:", companyData);

          // Set the company data - assuming the API returns an array or single object
          if (Array.isArray(companyData)) {
            setCompanyCodes(companyData);
            // Auto-select the first company if only one is returned
            if (companyData.length === 1) {
              setPoData((prev) => ({
                ...prev,
                companyCode: companyData[0].companyCode,
              }));
            }
          } else if (companyData && companyData.companyCode) {
            // If it's a single object, convert to array and set
            setCompanyCodes([companyData]);
            setPoData((prev) => ({
              ...prev,
              companyCode: companyData.companyCode,
            }));
          }
        }

        // Remove fetchCompanyCodes from here - only load other data
        const [
          customersData,
          projectsData,
          itemsData,
          resourcesData,
          vendorsData,
          taxCodesData,
          hsnCodesData,
          itemTypesData,
          currencyCode,
          allResourceData
        ] = await Promise.all([
          fetchCustomersByOrgId(user?.organisationId),
          fetchrevenueProjects(),
          fetchItemsByOrgId(user?.organisationId),
          getSalesPerson(user?.organisationId),
          getAllMerchants(user?.organisationId),
          fetchTaxCodes(),
          fetchHSNCodes(),
          getItemTypes(),
          fetchCurrency(),
          fetchResourceByOrgId(user?.organisationId),
        ]);

        // Add detailed logging
        console.log("Raw API Responses:");
        console.log("Customers:", customersData);
        console.log("Projects:", projectsData);
        console.log("Items:", itemsData);
        console.log("Resources:", resourcesData);
        console.log("Vendors:", vendorsData);
        console.log("Tax Codes:", taxCodesData);
        console.log("HSN Codes:", hsnCodesData);

        // Don't set company codes here - they're already set from getCompanyByOrganisationId
        setCustomers(customersData);
        console.log("Customers Data:", customersData);
        setProjects(projectsData);
        console.log("Projects Data:", projectsData);
        setItems(itemsData);
        console.log("Items Data:", itemsData);
        setResources(resourcesData);
        console.log("Resources Data:", resourcesData);
        setVendors(vendorsData);
        console.log("Vendors Data:", vendorsData);
        setTaxCodes(taxCodesData);
        console.log("Tax Codes Data:", taxCodesData);
        setHsnCodes(hsnCodesData);
        console.log("HSN Codes Data:", hsnCodesData);
        setItemTypes(itemTypesData || []);
        setCurrencyCode(currencyCode || []);
        setAllResource(allResourceData || []);
      } catch (error) {
        toast.error("Failed to load data");
        console.error("Error loading data:", error);
      } finally {
        setLoadingCompanyCodes(false);
        setLoadingCustomers(false);
        setLoadingProjects(false);
        setLoadingItems(false);
        setLoadingResources(false);
        setLoadingVendors(false);
        setLoadingTaxCodes(false);
        setLoadingHsnCodes(false);
        setLoadingItemTypes(false);

      }
    };

    loadData();
  }, [orgId]); // Add orgId as dependency

  const categoryOptions = [
    { value: "New Project", label: "New Project" },
    { value: "CR to existing Project", label: "CR to existing Project" },
    { value: "Staffing requirement", label: "Staffing requirement" },
    { value: "Extension of Staffing", label: "Extension of Staffing" },
  ];

 const handleChange = async (e) => {
  const { name, value } = e.target;

  setPoData((prev) => ({
    ...prev,
    [name]: value,
  }));

  /* ---------------- LOAD PROJECTS ON CUSTOMER CHANGE ---------------- */
if (name === "customerCode") {
  if (!value) {
    // Clear everything if customer is unselected
    setProjects([]);
    setPoData((prev) => ({
      ...prev,
      customerCode: "",
      projectCode: "",
      currencyCode: "",
      itemData: prev.itemData.map((row) => ({
        ...row,
        currencyCode: "",
      })),
    }));
    return;
  }

  // 🔹 FIND SELECTED CUSTOMER
  const selectedCustomer = customers.find(
    (cust) => cust.customerCode === value
  );

  const customerCurrency = selectedCustomer?.currencyCode || "";

  // 🔹 UPDATE HEADER + ITEM ROWS IN ONE STATE UPDATE
  setPoData((prev) => ({
    ...prev,
    customerCode: value,
    projectCode: "",
    currencyCode: customerCurrency,
    itemData: prev.itemData.map((row) => ({
      ...row,
      // inherit only if not manually set
      currencyCode: row.currencyCode || customerCurrency,
    })),
  }));

  // 🔹 LOAD PROJECTS FOR CUSTOMER
  try {
    setLoadingProjects(true);
    setProjects([]);
    const projectsData = await fetchProjectsByCustomer(value);
    setProjects(projectsData);
  } catch (err) {
    console.error("Failed to load projects:", err);
    toast.error("Failed to load projects for selected customer");
  } finally {
    setLoadingProjects(false);
  }

  return;
}

if (name === "currencyCode") {
  setPoData((prev) => ({
    ...prev,
    currencyCode: value,
    itemData: prev.itemData.map((row) => ({
      ...row,
      currencyCode: row.currencyCode || value, // 👈 don't override manually changed rows
    })),
  }));
  return;
}

};


 const handleItemChange = (index, e) => {
  const { name, value } = e.target;

  setPoData((prev) => {
    const itemData = [...prev.itemData];
    const row = { ...itemData[index] };

    /* ---------------- ITEM TYPE CHANGE ---------------- */
    if (name === "itemType") {
      itemData[index] = {
        ...row,
        itemType: value,
        item: "",
        itemDescription: "",
        taxType: "",
        cgst: "",
        sgst: "",
        igst: "",
        grandTotal: "",
      };
      return { ...prev, itemData };
    }

    /* ---------------- CLEAN NUMERIC INPUTS ---------------- */
    const cleanedValue =
      ["quantity", "price", "cgst", "sgst", "igst", "grandTotal"].includes(name)
        ? value.replace(/[^0-9.]/g, "")
        : value;

    row[name] = cleanedValue;

    /* ---------------- ITEM SELECTED → AUTO DESCRIPTION ---------------- */
    if (name === "item") {
      const selectedItem = items.find(
        (it) => it.itemCode === value
      );

      row.itemDescription = selectedItem?.itemName || "";
    }

    /* ---------------- PRICE CALCULATION ---------------- */
    const quantity = parseFloat(row.quantity) || 0;
    const price = parseFloat(row.price) || 0;
    const cgst = parseFloat(row.cgst) || 0;
    const sgst = parseFloat(row.sgst) || 0;
    const igst = parseFloat(row.igst) || 0;

    if (quantity && price) {
      const subtotal = quantity * price;
      const taxAmount = subtotal * ((cgst + sgst + igst) / 100);
      row.grandTotal = Math.round(subtotal + taxAmount).toString();
    } else {
      row.grandTotal = "";
    }

    itemData[index] = row;
    return { ...prev, itemData };
  });
};


  const handleTaxTypeChange = (index, e) => {
    const { value } = e.target;
    const itemData = [...poData.itemData];
    const selectedTax = taxCodes.find((tax) => tax.code === value);

    if (selectedTax) {
      itemData[index] = {
        ...itemData[index],
        taxType: value,
        cgst: selectedTax.cgst?.toString() || "0",
        sgst: selectedTax.sgst?.toString() || "0",
        igst: selectedTax.igst?.toString() || "0",
      };

      const quantity = parseFloat(itemData[index].quantity) || 0;
      const price = parseFloat(itemData[index].price) || 0;
      const cgst = parseFloat(itemData[index].cgst) || 0;
      const sgst = parseFloat(itemData[index].sgst) || 0;
      const igst = parseFloat(itemData[index].igst) || 0;

      const subtotal = quantity * price;
      const taxAmount = subtotal * ((cgst + sgst + igst) / 100);
      const grandTotal = subtotal + taxAmount;
      itemData[index].grandTotal = Math.round(grandTotal).toString();
    }

    setPoData({ ...poData, itemData });
  };

  const addNewItem = () => {
    setPoData({
      ...poData,
      itemData: [
        ...poData.itemData,
        {
          item: "",
          resource: "",
          vendor: "",
          quantity: "",
          price: "",
          taxType: "",
          cgst: "",
          sgst: "",
          igst: "",
          hsn: "",
          grandTotal: "",
           itemType: "",
           itemDescription: "",
           currencyCode: poData.currencyCode || "",
        },
      ],
    });
  };
  console.log(poData);
  const removeItem = (index) => {
    if (poData.itemData.length === 1) {
      toast.warning("At least one item is required");
      return;
    }

    const itemData = [...poData.itemData];
    itemData.splice(index, 1);
    setPoData({ ...poData, itemData });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    // Build transaction code (P2 for Incoming PO, S4 for Sales Order)
    const transactionCode = poData.transactionType === "Incoming PO" ? "P2" : "S4";

    // Normalize createdBy
    const createdBy = userId ? String(userId) : poData.createdBy || "";

    // Filter itemData: keep only rows that have at least an item + quantity + price.
    const filteredItems = (poData.itemData || []).filter((it) => {
      const hasItemCode = it.item && it.item.toString().trim() !== "";
      const hasQty = it.quantity && it.quantity.toString().trim() !== "" && !isNaN(Number(it.quantity));
      const hasPrice = it.price && it.price.toString().trim() !== "" && !isNaN(Number(it.price));
      // change conditions as per backend requirements; minimum require itemCode, quantity and price
      return hasItemCode && hasQty && hasPrice;
    });

    if (!filteredItems.length) {
      toast.error("At least one item with item code, quantity and price is required.");
      setLoading(false);
      return;
    }

    // Build payload exactly how backend expects it (itemData should be top-level)
    const payloadData = {
      ...poData,
      transactionType: transactionCode, // send code if backend expects code
      createdBy,
      itemData: filteredItems,
    };

    // If backend expects specific keys or date format adjust here (e.g., poDate)
    // console.log("Payload sent to API:", payloadData);
    const res = await axios.post(`${Base_URL}/Invoices/CreateIncomingPO`, payloadData);
    console.log("Save response:", res?.data?.message);

    // Reset form (keep createdBy as string of userId)
    setPoData({
      transactionType: "Incoming PO",
      companyCode: "",
      category: "",
      customerCode: "",
      projectCode: "",
      poNumber: "",
      poDate: "",
      salespersonCode: "",
      createdBy: String(userId),
      currencyCode: "",
      itemData: [
        {
          item: "",
          resource: "",
          vendor: "",
          quantity: "",
          price: "",
          taxType: "",
          cgst: "",
          sgst: "",
          igst: "",
          hsn: "",
          grandTotal: "",
        },
      ],
    });

    toast.success(`Document Saved Successfully ${res?.data?.message}`);
  } catch (error) {
    toast.error("Failed to save document");
    console.error("Error details:", error.response?.data || error.message || error);
  } finally {
    setLoading(false);
  }
};
const getFilteredItemsForRow = (index) => {
  const row = poData.itemData[index];
  if (!row?.itemType) return [];

  const prefix = String(row.itemType).slice(0, 4);

  return items.filter((it) =>
    String(it.itemCode || "").startsWith(prefix)
  );
};


  const isLoading =
    loading ||
    loadingCompanyCodes ||
    loadingCustomers ||
    loadingProjects ||
    loadingItems ||
    loadingResources ||
    loadingVendors ||
    loadingTaxCodes ||
    loadingHsnCodes;

  const isSalesOrder = poData.transactionType === "Sales Order";

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Incoming PO / Sales Order Session</h2>
 
        {isLoading && (
          <div className="loading-overlay">
            <Sample14 />
          </div>
        )}

        <Form onSubmit={handleSubmit} className="fields-form">
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Transaction Type <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="transactionType"
                  value={poData.transactionType}
                  onChange={handleChange}
                  required
                >
                  {transactionTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Company Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="companyCode"
                  value={poData.companyCode}
                  onChange={handleChange}
                  required
                  disabled={loadingCompanyCodes}
                >
                  <option value="">Select Company</option>
                  {companyCodes.map((company) => (
                    <option
                      key={company.companyCode}
                      value={company.companyCode}
                    >
                      {company.companyCode} - {company.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Category <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="category"
                  value={poData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Category</option>
                  {categoryOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Customer Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="customerCode"
                  value={poData.customerCode}
                  onChange={handleChange}
                  required
                  disabled={loadingCustomers}
                >
                  <option value="">Select Customer</option>
                  {customers.map((customer) => (
                    <option
                      key={customer.customerCode}
                      value={customer.customerCode}
                    >
                      {customer.customerCode} - {customer.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
  name="projectCode"
  value={poData.projectCode}
  onChange={handleChange}
  required
  disabled={!poData.customerCode || loadingProjects}
>
  <option value="">Select Project</option>

  {projects.length === 0 && poData.customerCode && !loadingProjects && (
    <option value="" disabled>
      No projects found for selected customer
    </option>
  )}

  {projects.map((project) => (
    <option key={project.projectId} value={project.projectId}>
      {project.projectId} - {project.prTitle}
    </option>
  ))}
</Form.Select>

              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  {isSalesOrder ? "Sales Order Number" : "PO Number"}{" "}
                  {!isSalesOrder && <span className="text-red">**</span>}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="poNumber"
                  value={poData.poNumber}
                  onChange={handleChange}
                  required={!isSalesOrder}
                  disabled={isSalesOrder}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  {isSalesOrder ? "Sales Order Date" : "PO Date"}{" "}
                  <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="poDate"
                  value={poData.poDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Salesperson Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="salespersonCode"
                  value={poData.salespersonCode}
                  onChange={handleChange}
                  required
                  disabled={loadingResources}
                >
                  <option value="">Select Salesperson</option>
                  {resources.map((resource) => (
                    <option
                      key={resource.resourceId}
                      value={resource.resourceId}
                    >
                      {resource.resourceId} - {resource.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
            <Form.Group className="mb-3">
                <Form.Label>
                  Currency Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="currencyCode"
                  value={poData.currencyCode}
                  onChange={handleChange}
                  required
                  disabled={loadingResources}
                >
                  <option value="">Select Currency</option>
                  {currencyCode.map((currency) => (
                    <option
                      key={currency.currencyCode}
                      value={currency.currencyCode}
                    >
                     {currency.currencyCode} - {currency.currencyName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* Price Summary Section */}
          <div className="price-summary-section mb-4 p-3 border rounded">
            <h4 className="price-summary-heading mb-3">Price Summary</h4>
            <Row>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Base Price</Form.Label>
                  <Form.Control
                    type="text"
                    value={priceSummary.totalBasePrice}
                    readOnly
                    className="font-weight-bold"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Tax Amount</Form.Label>
                  <Form.Control
                    type="text"
                    value={priceSummary.totalTaxAmount}
                    readOnly
                    className="font-weight-bold"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Round off</Form.Label>
                  <Form.Control
                    type="text"
                    value={priceSummary.roundOff}
                    readOnly
                    className="font-weight-bold"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Amount</Form.Label>
                  <Form.Control
                    type="text"
                    value={priceSummary.roundedTotalPrice}
                    readOnly
                    className="font-weight-bold"
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          <div className="item-data-section">
            <h4 className="item-data-heading mb-3">Item Data</h4>

            {poData.itemData.map((item, index) => (
              <div key={index} className="item-data-container">
                <div className="item-data-row">
                  {/* Item Type */}
<div className="item-data-field" style={{ width: "180px" }}>
  <Form.Group className="mb-3">
    <Form.Label>
      Item Type <span className="text-red">**</span>
    </Form.Label>
    <Form.Select
      name="itemType"
      value={item.itemType}
      onChange={(e) => handleItemChange(index, e)}
      required
      disabled={loadingItemTypes}
    >
      <option value="">Select Item Type</option>
      {itemTypes.map((type) => (
        <option key={type.value} value={type.value}>
          {type.label}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</div>

                  {/* Item */}
                  <div className="item-data-field" style={{ width: "180px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Item <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Select
  name="item"
  value={item.item}
  onChange={(e) => handleItemChange(index, e)}
  required
  disabled={!item.itemType || loadingItems}
>
  <option value="">Select Item</option>

  {getFilteredItemsForRow(index).length === 0 &&
    item.itemType && (
      <option value="" disabled>
        No items match selected type
      </option>
    )}

  {getFilteredItemsForRow(index).map((itemOption) => (
    <option
      key={itemOption.itemCode}
      value={itemOption.itemCode}
    >
      {itemOption.itemCode} - {itemOption.itemName}
    </option>
  ))}
</Form.Select>

                    </Form.Group>
                  </div>
                  {/* Item Description */}
<div className="item-data-field" style={{ width: "250px" }}>
  <Form.Group className="mb-3">
    <Form.Label>
      Item Description <span className="text-red">**</span>
    </Form.Label>
    <Form.Control
      type="text"
      name="itemDescription"
      value={item.itemDescription}
      onChange={(e) => handleItemChange(index, e)}
      placeholder="Item description"
      required
      disabled={item.itemType === "FM00"}
    />
  </Form.Group>
</div>


                  {/* Resource */}
                  <div className="item-data-field" style={{ width: "180px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Resource</Form.Label>
                      <Form.Select
                        name="resource"
                        value={item.resource}
                        onChange={(e) => handleItemChange(index, e)}
                        disabled={loadingResources}
                      >
                        <option value="">Select Resource</option>
                        {allResource.map((resource) => (
                          <option
                            key={resource.resourceId}
                            value={resource.resourceId}
                          >
                            {resource.resourceId} - {resource.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {/* Vendor */}
                  <div className="item-data-field" style={{ width: "180px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Vendor </Form.Label>
                      <Form.Select
                        name="vendor"
                        value={item.vendor}
                        onChange={(e) => handleItemChange(index, e)}
                        disabled={loadingVendors}
                      >
                        <option value="">Select Vendor</option>
                        {vendors.map((vendor) => (
                          <option
                            key={vendor.vendorCode}
                            value={vendor.vendorCode}
                          >
                            {vendor.vendorCode} - {vendor.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {/* Quantity */}
                  <div className="item-data-field" style={{ width: "100px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Qty <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="quantity"
                        value={item.quantity}
                        onChange={(e) => handleItemChange(index, e)}
                        required
                      />
                    </Form.Group>
                  </div>

                  {/* Price */}
                  <div className="item-data-field" style={{ width: "100px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Price <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="price"
                        value={item.price}
                        onChange={(e) => handleItemChange(index, e)}
                        required
                      />
                    </Form.Group>
                  </div>
                  {/* Item Currency */}
<div className="item-data-field" style={{ width: "130px" }}>
  <Form.Group className="mb-3">
    <Form.Label>
      Currency <span className="text-red">**</span>
    </Form.Label>
    <Form.Select
      name="currencyCode"
      value={item.currencyCode || poData.currencyCode}
      onChange={(e) => handleItemChange(index, e)}
      required
    >
      <option value="">Select</option>
      {currencyCode.map((cur) => (
        <option key={cur.currencyCode} value={cur.currencyCode}>
          {cur.currencyCode}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</div>


                  {/* Tax Type */}
                  <div className="item-data-field" style={{ width: "200px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Tax Code <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Select
                        name="taxType"
                        value={item.taxType}
                        onChange={(e) => handleTaxTypeChange(index, e)}
                        required
                        disabled={loadingTaxCodes}
                      >
                        <option value="">Select Tax Code</option>
                        {taxCodes.map((tax) => (
                          <option key={tax.code} value={tax.code}>
                            {tax.code} - {tax.description} - {tax.type}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {/* CGST */}
                  <div className="item-data-field" style={{ width: "80px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>CGST %</Form.Label>
                      <Form.Control
                        type="text"
                        name="cgst"
                        value={item.cgst}
                        onChange={(e) => handleItemChange(index, e)}
                      />
                    </Form.Group>
                  </div>

                  {/* SGST */}
                  <div className="item-data-field" style={{ width: "80px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>SGST %</Form.Label>
                      <Form.Control
                        type="text"
                        name="sgst"
                        value={item.sgst}
                        onChange={(e) => handleItemChange(index, e)}
                      />
                    </Form.Group>
                  </div>

                  {/* IGST */}
                  <div className="item-data-field" style={{ width: "80px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>IGST %</Form.Label>
                      <Form.Control
                        type="text"
                        name="igst"
                        value={item.igst}
                        onChange={(e) => handleItemChange(index, e)}
                      />
                    </Form.Group>
                  </div>

                  {/* HSN */}
                  <div className="item-data-field" style={{ width: "150px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        HSN <span className="text-red"></span>
                      </Form.Label>
                      <Form.Select
                        name="hsn"
                        value={item.hsn}
                        onChange={(e) => handleItemChange(index, e)}
                        
                        disabled={loadingHsnCodes}
                      >
                        <option value="">Select HSN</option>
                        {hsnCodes.map((hsn) => (
                          <option key={hsn.code} value={hsn.code}>
                            {hsn.code} - {hsn.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {/* Grand Total */}
                  <div className="item-data-field" style={{ width: "120px" }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Grand Total</Form.Label>
                      <Form.Control
                        type="text"
                        name="grandTotal"
                        value={item.grandTotal}
                        readOnly
                      />
                    </Form.Group>
                  </div>

                  {/* Action Buttons */}
                  <div className="item-data-field" style={{ width: "150px" }}>
                    <div className="d-flex gap-2 mb-3">
                      <Button
                        variant="danger"
                        onClick={() => removeItem(index)}
                        className="item-action-btn"
                        disabled={poData.itemData.length === 1}
                      >
                        Remove
                      </Button>
                      {index === poData.itemData.length - 1 && (
                        <Button
                          variant="success"
                          onClick={addNewItem}
                          className="item-action-btn"
                        >
                          Add
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="fields-btn-container">
            <Button
              variant="primary"
              type="submit"
              className="fields-submit"
              disabled={isLoading}
            >
              {loading ? "Saving..." : "Save Document"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default IncomingPO;
